// import React, { useState } from 'react';
// import {
//     FaBook,
//     FaGlobeAsia,
//     FaGavel,
//     FaHistory,
//     FaChartLine,
//     FaGlobe,
//     FaLaptop,
//     FaNewspaper,
//     FaChevronRight,
//     FaChevronDown,
//     FaSitemap,
//     FaStar
// } from 'react-icons/fa';

// const SubFooter = ({ data }) => {
//     const [expandedCategories, setExpandedCategories] = useState({});

//     // Toggle category expansion
//     const toggleCategory = (categoryName) => {
//         setExpandedCategories(prev => ({
//             ...prev,
//             [categoryName]: !prev[categoryName]
//         }));
//     };

//     // Category icons mapping
//     const categoryIcons = {
//         biology: <FaBook style={{ width: '14px', height: '14px' }} />,
//         geography: <FaGlobeAsia style={{ width: '14px', height: '14px' }} />,
//         polity: <FaGavel style={{ width: '14px', height: '14px' }} />,
//         history: <FaHistory style={{ width: '14px', height: '14px' }} />,
//         economics: <FaChartLine style={{ width: '14px', height: '14px' }} />,
//         static: <FaGlobe style={{ width: '14px', height: '14px' }} />,
//         current: <FaNewspaper style={{ width: '14px', height: '14px' }} />,
//         computer: <FaLaptop style={{ width: '14px', height: '14px' }} />
//     };

//     // Category colors
//     const categoryColors = {
//         biology: '#059669',
//         geography: '#2563eb',
//         polity: '#9333ea',
//         history: '#d97706',
//         economics: '#16a34a',
//         static: '#4f46e5',
//         current: '#e11d48',
//         computer: '#475569'
//     };

//     // Function to construct the full URL
//     const constructUrl = (category, subIndex, fileName) => {
//         return `/blogsCategory/${category}/${subIndex}/${fileName}`;
//     };

//     // Calculate stats
//     const totalArticles = data.categories.reduce((acc, cat) =>
//         acc + cat.subCategories.reduce((subAcc, sub) =>
//             subAcc + sub.pages.length, 0
//         ), 0
//     );

//     return (
//         <div style={{
//             backgroundColor: '#ffffff',
//             borderTop: '1px solid #eaeef2',
//             width: '100%'
//         }}>
//             <div style={{
//                 maxWidth: '1000px',
//                 margin: '0 auto',
//                 padding: '32px 20px'
//             }}>
//                 {/* Header */}
//                 <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px',
//                     marginBottom: '24px'
//                 }}>
//                     <FaSitemap style={{ width: '16px', height: '16px', color: '#7c8ba0' }} />
//                     <h2 style={{
//                         fontSize: '16px',
//                         fontWeight: '500',
//                         color: '#1e2a3a',
//                         margin: 0,
//                         letterSpacing: '0.2px'
//                     }}>
//                         Quick Links
//                     </h2>
//                     <div style={{
//                         flex: 1,
//                         height: '1px',
//                         backgroundColor: '#eaeef2'
//                     }}></div>
//                     <span style={{
//                         fontSize: '12px',
//                         color: '#7c8ba0'
//                     }}>
//                         {totalArticles} resources
//                     </span>
//                 </div>

//                 {/* Accordion Grid */}
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: 'repeat(1, 1fr)',
//                     gap: '8px'
//                 }}>
//                     <style>
//                         {`
//                             @media (min-width: 640px) {
//                                 .accordion-grid {
//                                     grid-template-columns: repeat(2, 1fr) !important;
//                                 }
//                             }
//                             @media (min-width: 1024px) {
//                                 .accordion-grid {
//                                     grid-template-columns: repeat(4, 1fr) !important;
//                                 }
//                             }
//                         `}
//                     </style>

//                     {data.categories.map((category) => {
//                         const isExpanded = expandedCategories[category.category];
//                         const categoryTotal = category.subCategories.reduce((acc, sub) => acc + sub.pages.length, 0);

//                         return (
//                             <div key={category.category} style={{
//                                 backgroundColor: '#f8fafc',
//                                 borderRadius: '8px',
//                                 border: '1px solid #eef2f6',
//                                 overflow: 'hidden'
//                             }}>
//                                 {/* Accordion Header */}
//                                 <div
//                                     onClick={() => toggleCategory(category.category)}
//                                     style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '8px',
//                                         padding: '12px 14px',
//                                         backgroundColor: '#ffffff',
//                                         cursor: 'pointer',
//                                         borderBottom: isExpanded ? '1px solid #eef2f6' : 'none',
//                                         transition: 'background-color 0.2s'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
//                                 >
//                                     <span style={{ color: categoryColors[category.category] }}>
//                                         {categoryIcons[category.category] || <FaBook style={{ width: '14px', height: '14px' }} />}
//                                     </span>
//                                     <h3 style={{
//                                         fontSize: '13px',
//                                         fontWeight: '500',
//                                         color: '#1e2a3a',
//                                         textTransform: 'capitalize',
//                                         margin: 0,
//                                         flex: 1
//                                     }}>
//                                         {category.category}
//                                     </h3>
//                                     <span style={{
//                                         fontSize: '11px',
//                                         backgroundColor: '#eef2f6',
//                                         padding: '2px 6px',
//                                         borderRadius: '12px',
//                                         color: '#5a6b7f',
//                                         fontWeight: '400',
//                                         marginRight: '4px'
//                                     }}>
//                                         {categoryTotal}
//                                     </span>
//                                     {isExpanded ?
//                                         <FaChevronDown style={{ width: '11px', height: '11px', color: '#8a9bb5' }} /> :
//                                         <FaChevronRight style={{ width: '11px', height: '11px', color: '#8a9bb5' }} />
//                                     }
//                                 </div>

//                                 {/* Accordion Content */}
//                                 {isExpanded && (
//                                     <div style={{
//                                         padding: '14px',
//                                         backgroundColor: '#f8fafc'
//                                     }}>
//                                         {/* Links */}
//                                         <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                                             {category.subCategories.map((subCategory, subIndex) => (
//                                                 <div key={subCategory.title} style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
//                                                     {/* Subcategory Title */}
//                                                     <h4 style={{
//                                                         fontSize: '10px',
//                                                         fontWeight: '600',
//                                                         color: '#8a9bb5',
//                                                         textTransform: 'uppercase',
//                                                         letterSpacing: '0.3px',
//                                                         margin: '0 0 4px 0'
//                                                     }}>
//                                                         {subCategory.title}
//                                                     </h4>

//                                                     {/* Page Links */}
//                                                     {subCategory.pages.slice(0, 5).map((page) => (
//                                                         <a
//                                                             key={`${category.category}-${subIndex}-${page.id}`}
//                                                             href={constructUrl(category.category, subIndex, page.fileName)}
//                                                             style={{
//                                                                 display: 'flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'space-between',
//                                                                 padding: '6px 8px',
//                                                                 borderRadius: '6px',
//                                                                 textDecoration: 'none',
//                                                                 fontSize: '12px',
//                                                                 lineHeight: '1.4',
//                                                                 color: '#4a5a6e',
//                                                                 transition: 'background-color 0.2s',
//                                                                 cursor: 'pointer'
//                                                             }}
//                                                             onMouseEnter={(e) => {
//                                                                 e.currentTarget.style.backgroundColor = '#ffffff';
//                                                             }}
//                                                             onMouseLeave={(e) => {
//                                                                 e.currentTarget.style.backgroundColor = 'transparent';
//                                                             }}
//                                                         >
//                                                             <span style={{
//                                                                 flex: 1,
//                                                                 overflow: 'hidden',
//                                                                 textOverflow: 'ellipsis',
//                                                                 whiteSpace: 'nowrap',
//                                                                 paddingRight: '6px',
//                                                                 fontSize: '12px'
//                                                             }}>
//                                                                 {page.fileTitle}
//                                                             </span>
//                                                             {page.subscriptionRequired && (
//                                                                 <FaStar style={{
//                                                                     width: '10px',
//                                                                     height: '10px',
//                                                                     color: '#f5b342',
//                                                                     flexShrink: 0
//                                                                 }} />
//                                                             )}
//                                                         </a>
//                                                     ))}

//                                                     {subCategory.pages.length > 5 && (
//                                                         <a
//                                                             href={`/category/${category.category}`}
//                                                             style={{
//                                                                 fontSize: '11px',
//                                                                 color: '#8a9bb5',
//                                                                 textDecoration: 'none',
//                                                                 padding: '5px 8px',
//                                                                 display: 'flex',
//                                                                 alignItems: 'center',
//                                                                 gap: '4px',
//                                                                 marginTop: '2px'
//                                                             }}
//                                                             onMouseEnter={(e) => e.currentTarget.style.color = '#5a6b7f'}
//                                                             onMouseLeave={(e) => e.currentTarget.style.color = '#8a9bb5'}
//                                                         >
//                                                             <span style={{ fontSize: '11px' }}>+{subCategory.pages.length - 5} more</span>
//                                                             <FaChevronRight style={{ width: '8px', height: '8px' }} />
//                                                         </a>
//                                                     )}
//                                                 </div>
//                                             ))}
//                                         </div>

//                                         {/* Category Footer Link */}
//                                         <div style={{
//                                             marginTop: '16px',
//                                             paddingTop: '12px',
//                                             borderTop: '1px solid #e2e9f2',
//                                             textAlign: 'center'
//                                         }}>
//                                             <a
//                                                 href={`/category/${category.category}`}
//                                                 style={{
//                                                     display: 'inline-flex',
//                                                     alignItems: 'center',
//                                                     gap: '4px',
//                                                     fontSize: '11px',
//                                                     fontWeight: '400',
//                                                     color: '#5a6b7f',
//                                                     textDecoration: 'none'
//                                                 }}
//                                                 onMouseEnter={(e) => e.currentTarget.style.color = '#1e2a3a'}
//                                                 onMouseLeave={(e) => e.currentTarget.style.color = '#5a6b7f'}
//                                             >
//                                                 <span style={{ fontSize: '11px' }}>View all {category.category}</span>
//                                                 <FaChevronRight style={{ width: '9px', height: '9px' }} />
//                                             </a>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         );
//                     })}
//                 </div>

//                 {/* Compact Stats */}
//                 <div style={{
//                     marginTop: '28px',
//                     paddingTop: '20px',
//                     borderTop: '1px solid #eaeef2',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     gap: '28px',
//                     flexWrap: 'wrap'
//                 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                         <span style={{ fontSize: '15px', fontWeight: '400', color: '#1e2a3a' }}>{data.categories.length}</span>
//                         <span style={{ fontSize: '11px', color: '#7c8ba0' }}>categories</span>
//                     </div>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                         <span style={{ fontSize: '15px', fontWeight: '400', color: '#1e2a3a' }}>{totalArticles}</span>
//                         <span style={{ fontSize: '11px', color: '#7c8ba0' }}>articles</span>
//                     </div>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                         <span style={{ fontSize: '15px', fontWeight: '400', color: '#f5b342' }}>✨</span>
//                         <span style={{ fontSize: '11px', color: '#7c8ba0' }}>free access</span>
//                     </div>
//                 </div>

//                 {/* Footer Text */}
//                 <div style={{
//                     marginTop: '20px',
//                     textAlign: 'center',
//                     fontSize: '10px',
//                     color: '#9aabbf',
//                     letterSpacing: '0.2px'
//                 }}>
//                     Click on categories to expand and explore topics
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SubFooter;

//OLDER VERSION
// import React, { useState, useContext } from 'react';
// import { themeContext } from '../Context';

// import {
//     FaBook,
//     FaGlobeAsia,
//     FaGavel,
//     FaHistory,
//     FaChartLine,
//     FaGlobe,
//     FaLaptop,
//     FaNewspaper,
//     FaChevronRight,
//     FaChevronDown,
//     FaSitemap,
//     FaStar
// } from 'react-icons/fa';

// const SubFooter = ({ data }) => {
//     const [expandedCategories, setExpandedCategories] = useState({});

//     const theme = useContext(themeContext);
//     const darkMode = theme.state.darkMode;

//     // Toggle category expansion
//     const toggleCategory = (categoryName) => {
//         setExpandedCategories(prev => ({
//             ...prev,
//             [categoryName]: !prev[categoryName]
//         }));
//     };

//     // Category icons mapping
//     const categoryIcons = {
//         biology: <FaBook style={{ width: '14px', height: '14px' }} />,
//         geography: <FaGlobeAsia style={{ width: '14px', height: '14px' }} />,
//         polity: <FaGavel style={{ width: '14px', height: '14px' }} />,
//         history: <FaHistory style={{ width: '14px', height: '14px' }} />,
//         economics: <FaChartLine style={{ width: '14px', height: '14px' }} />,
//         static: <FaGlobe style={{ width: '14px', height: '14px' }} />,
//         current: <FaNewspaper style={{ width: '14px', height: '14px' }} />,
//         computer: <FaLaptop style={{ width: '14px', height: '14px' }} />
//     };

//     // Category colors
//     const categoryColors = {
//         biology: '#059669',
//         geography: '#2563eb',
//         polity: '#9333ea',
//         history: '#d97706',
//         economics: '#16a34a',
//         static: '#4f46e5',
//         current: '#e11d48',
//         computer: '#475569'
//     };

//     // Function to construct the full URL
//     const constructUrl = (category, subIndex, fileName) => {
//         return `/blogsCategory/${category}/${subIndex}/${fileName}`;
//     };

//     // Calculate stats
//     const totalArticles = data.categories.reduce((acc, cat) =>
//         acc + cat.subCategories.reduce((subAcc, sub) =>
//             subAcc + sub.pages.length, 0
//         ), 0
//     );

//     return (
//         <div style={{
//             backgroundColor: '#ffffff',
//             borderTop: '1px solid #eaeef2',
//             width: '100%'
//         }}>
//             <div style={{
//                 maxWidth: '1200px',
//                 margin: '0 auto',
//                 padding: '36px 20px'
//             }}>
//                 {/* Header */}
//                 <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px',
//                     marginBottom: '28px'
//                 }}>
//                     <FaSitemap style={{ width: '18px', height: '18px', color: '#7c8ba0' }} />
//                     <h2 style={{
//                         fontSize: '17px',
//                         fontWeight: '500',
//                         color: '#1e2a3a',
//                         margin: 0,
//                         letterSpacing: '0.2px'
//                     }}>
//                         All Study Resources
//                     </h2>
//                     <div style={{
//                         flex: 1,
//                         height: '1px',
//                         backgroundColor: '#eaeef2'
//                     }}></div>
//                     <span style={{
//                         fontSize: '12px',
//                         color: '#7c8ba0',
//                         backgroundColor: '#f0f4fa',
//                         padding: '4px 10px',
//                         borderRadius: '30px'
//                     }}>
//                         {totalArticles} topics
//                     </span>
//                 </div>

//                 {/* Accordion Grid */}
//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: 'repeat(1, 1fr)',
//                     gap: '12px'
//                 }}>
//                     <style>
//                         {`
//                             @media (min-width: 640px) {
//                                 .accordion-grid {
//                                     grid-template-columns: repeat(2, 1fr) !important;
//                                 }
//                             }
//                             @media (min-width: 1024px) {
//                                 .accordion-grid {
//                                     grid-template-columns: repeat(4, 1fr) !important;
//                                 }
//                             }
//                         `}
//                     </style>

//                     {data.categories.map((category) => {
//                         const isExpanded = expandedCategories[category.category];
//                         const categoryTotal = category.subCategories.reduce((acc, sub) => acc + sub.pages.length, 0);

//                         return (
//                             <div key={category.category} style={{
//                                 backgroundColor: '#ffffff',
//                                 borderRadius: '12px',
//                                 border: '1px solid #eef2f8',
//                                 overflow: 'hidden',
//                                 boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
//                             }}>
//                                 {/* Accordion Header - Clickable */}
//                                 <div
//                                     onClick={() => toggleCategory(category.category)}
//                                     style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '8px',
//                                         padding: '16px 16px',
//                                         backgroundColor: '#f9fcff',
//                                         cursor: 'pointer',
//                                         borderBottom: isExpanded ? '1px solid #eef2f8' : 'none',
//                                         transition: 'background-color 0.2s'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f9fcff'}
//                                 >
//                                     <span style={{ color: categoryColors[category.category] }}>
//                                         {categoryIcons[category.category] || <FaBook style={{ width: '15px', height: '15px' }} />}
//                                     </span>
//                                     <h3 style={{
//                                         fontSize: '14px',
//                                         fontWeight: '600',
//                                         color: '#1e2a3a',
//                                         textTransform: 'capitalize',
//                                         margin: 0,
//                                         flex: 1
//                                     }}>
//                                         {category.category}
//                                     </h3>
//                                     <span style={{
//                                         fontSize: '11px',
//                                         backgroundColor: '#ffffff',
//                                         padding: '3px 8px',
//                                         borderRadius: '30px',
//                                         color: '#5a6b7f',
//                                         fontWeight: '500',
//                                         marginRight: '4px',
//                                         border: '1px solid #e0e8f0'
//                                     }}>
//                                         {categoryTotal}
//                                     </span>
//                                     {isExpanded ?
//                                         <FaChevronDown style={{ width: '12px', height: '12px', color: '#8a9bb5' }} /> :
//                                         <FaChevronRight style={{ width: '12px', height: '12px', color: '#8a9bb5' }} />
//                                     }
//                                 </div>

//                                 {/* Accordion Content - All links visible when expanded */}
//                                 {isExpanded && (
//                                     <div style={{
//                                         padding: '20px 16px',
//                                         backgroundColor: '#ffffff',
//                                         maxHeight: '400px',
//                                         overflowY: 'auto'
//                                     }}>
//                                         {/* All Links - No truncation, everything visible */}
//                                         <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                                             {category.subCategories.map((subCategory, subIndex) => (
//                                                 <div key={subCategory.title} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//                                                     {/* Subcategory Title */}
//                                                     <h4 style={{
//                                                         fontSize: '10px',
//                                                         fontWeight: '600',
//                                                         color: '#9aabbf',
//                                                         textTransform: 'uppercase',
//                                                         letterSpacing: '0.3px',
//                                                         margin: '0 0 2px 4px'
//                                                     }}>
//                                                         {subCategory.title}
//                                                     </h4>

//                                                     {/* ALL Page Links - No "more" links */}
//                                                     {subCategory.pages.map((page) => (
//                                                         <a
//                                                             key={`${category.category}-${subIndex}-${page.id}`}
//                                                             href={constructUrl(category.category, subIndex, page.fileName)}
//                                                             style={{
//                                                                 display: 'flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'space-between',
//                                                                 padding: '8px 12px',
//                                                                 borderRadius: '8px',
//                                                                 textDecoration: 'none',
//                                                                 fontSize: '12px',
//                                                                 lineHeight: '1.4',
//                                                                 color: '#4a5a6e',
//                                                                 backgroundColor: '#f9fcff',
//                                                                 border: '1px solid #f0f4fa',
//                                                                 transition: 'all 0.2s',
//                                                                 cursor: 'pointer'
//                                                             }}
//                                                             onMouseEnter={(e) => {
//                                                                 e.currentTarget.style.backgroundColor = '#ffffff';
//                                                                 e.currentTarget.style.borderColor = '#d0ddeb';
//                                                                 e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.02)';
//                                                             }}
//                                                             onMouseLeave={(e) => {
//                                                                 e.currentTarget.style.backgroundColor = '#f9fcff';
//                                                                 e.currentTarget.style.borderColor = '#f0f4fa';
//                                                                 e.currentTarget.style.boxShadow = 'none';
//                                                             }}
//                                                         >
//                                                             <span style={{
//                                                                 flex: 1,
//                                                                 overflow: 'hidden',
//                                                                 textOverflow: 'ellipsis',
//                                                                 whiteSpace: 'nowrap',
//                                                                 paddingRight: '8px',
//                                                                 fontSize: '12px'
//                                                             }}>
//                                                                 {page.fileTitle}
//                                                             </span>
//                                                             {page.subscriptionRequired && (
//                                                                 <FaStar style={{
//                                                                     width: '10px',
//                                                                     height: '10px',
//                                                                     color: '#f5b342',
//                                                                     flexShrink: 0
//                                                                 }} />
//                                                             )}
//                                                         </a>
//                                                     ))}
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* When collapsed, show minimal preview */}
//                                 {!isExpanded && (
//                                     <div style={{
//                                         padding: '12px 16px',
//                                         backgroundColor: '#ffffff',
//                                         color: '#8a9bb5',
//                                         fontSize: '11px',
//                                         fontStyle: 'italic'
//                                     }}>
//                                         {category.subCategories.length} subcategories · Click to expand
//                                     </div>
//                                 )}
//                             </div>
//                         );
//                     })}
//                 </div>

//                 {/* Simple Stats */}
//                 <div style={{
//                     marginTop: '32px',
//                     paddingTop: '24px',
//                     borderTop: '1px solid #eaeef2',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     gap: '32px',
//                     flexWrap: 'wrap'
//                 }}>
//                     <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
//                         <span style={{ fontSize: '16px', fontWeight: '500', color: '#1e2a3a' }}>{data.categories.length}</span>
//                         <span style={{ fontSize: '11px', color: '#8a9bb5' }}>categories</span>
//                     </div>
//                     <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
//                         <span style={{ fontSize: '16px', fontWeight: '500', color: '#1e2a3a' }}>{totalArticles}</span>
//                         <span style={{ fontSize: '11px', color: '#8a9bb5' }}>total articles</span>
//                     </div>
//                     <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
//                         <span style={{ fontSize: '16px', fontWeight: '500', color: '#f5b342' }}>✦ Free</span>
//                         <span style={{ fontSize: '11px', color: '#8a9bb5' }}>access</span>
//                     </div>
//                 </div>

//                 {/* Instruction */}
//                 <div style={{
//                     marginTop: '20px',
//                     textAlign: 'center',
//                     fontSize: '10px',
//                     color: '#b1c3d8',
//                     letterSpacing: '0.2px'
//                 }}>
//                     Click on any category to expand and view all topics
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SubFooter;

import React, { useState, useContext } from 'react';
import { themeContext } from '../Context';
import { Helmet } from 'react-helmet';

import {
    FaBook,
    FaGlobeAsia,
    FaGavel,
    FaHistory,
    FaChartLine,
    FaGlobe,
    FaLaptop,
    FaNewspaper,
    FaChevronRight,
    FaChevronDown,
    FaSitemap,
    FaStar
} from 'react-icons/fa';

const SubFooter = ({ data }) => {
    const [expandedCategories, setExpandedCategories] = useState({});

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

    // Toggle category expansion
    const toggleCategory = (categoryName) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryName]: !prev[categoryName]
        }));
    };

    // Category icons mapping
    const categoryIcons = {
        biology: <FaBook style={{ width: '14px', height: '14px' }} />,
        geography: <FaGlobeAsia style={{ width: '14px', height: '14px' }} />,
        polity: <FaGavel style={{ width: '14px', height: '14px' }} />,
        history: <FaHistory style={{ width: '14px', height: '14px' }} />,
        economics: <FaChartLine style={{ width: '14px', height: '14px' }} />,
        static: <FaGlobe style={{ width: '14px', height: '14px' }} />,
        current: <FaNewspaper style={{ width: '14px', height: '14px' }} />,
        computer: <FaLaptop style={{ width: '14px', height: '14px' }} />
    };

    // Category colors
    const categoryColors = {
        biology: '#059669',
        geography: '#2563eb',
        polity: '#9333ea',
        history: '#d97706',
        economics: '#16a34a',
        static: '#4f46e5',
        current: '#e11d48',
        computer: '#475569'
    };

    // Function to construct the full URL
    const constructUrl = (category, subIndex, fileName) => {
        return `/blogsCategory/${category}/${subIndex}/${fileName}`;
    };

    // Calculate stats
    const totalArticles = data.categories.reduce((acc, cat) =>
        acc + cat.subCategories.reduce((subAcc, sub) =>
            subAcc + sub.pages.length, 0
        ), 0
    );

    // Dark mode styles
    const styles = {
        container: {
            backgroundColor: darkMode ? 'rgb(26, 26, 26)' : '#ffffff',
            borderTop: darkMode ? '1px solid #1e293b' : '1px solid #eaeef2',
            width: '100%'
        },
        headerIcon: {
            color: darkMode ? '#94a3b8' : '#7c8ba0'
        },
        headerTitle: {
            fontSize: '17px',
            fontWeight: '500',
            color: darkMode ? '#f1f5f9' : '#1e2a3a',
            margin: 0,
            letterSpacing: '0.2px'
        },
        headerDivider: {
            flex: 1,
            height: '1px',
            backgroundColor: darkMode ? '#1e293b' : '#eaeef2'
        },
        headerCount: {
            fontSize: '12px',
            color: darkMode ? '#94a3b8' : '#7c8ba0',
            backgroundColor: darkMode ? '#1e293b' : '#f0f4fa',
            padding: '4px 10px',
            borderRadius: '30px'
        },
        categoryCard: {
            backgroundColor: darkMode ? '#1e293b' : '#ffffff',
            borderRadius: '12px',
            border: darkMode ? '1px solid #334155' : '1px solid #eef2f8',
            overflow: 'hidden',
            boxShadow: darkMode ? '0 2px 4px rgba(0,0,0,0.2)' : '0 2px 4px rgba(0,0,0,0.02)'
        },
        categoryHeader: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '16px 16px',
            backgroundColor: darkMode ? '#1e293b' : '#f9fcff',
            cursor: 'pointer',
            borderBottom: 'none',
            transition: 'background-color 0.2s'
        },
        categoryHeaderExpanded: {
            borderBottom: darkMode ? '1px solid #334155' : '1px solid #eef2f8'
        },
        categoryTitle: {
            fontSize: '14px',
            fontWeight: '600',
            color: darkMode ? '#f1f5f9' : '#1e2a3a',
            textTransform: 'capitalize',
            margin: 0,
            flex: 1
        },
        categoryCount: {
            fontSize: '11px',
            backgroundColor: darkMode ? '#0f172a' : '#ffffff',
            padding: '3px 8px',
            borderRadius: '30px',
            color: darkMode ? '#94a3b8' : '#5a6b7f',
            fontWeight: '500',
            marginRight: '4px',
            border: darkMode ? '1px solid #475569' : '1px solid #e0e8f0'
        },
        chevronIcon: {
            color: darkMode ? '#64748b' : '#8a9bb5'
        },
        expandedContent: {
            padding: '20px 16px',
            backgroundColor: darkMode ? '#0f172a' : '#ffffff',
            maxHeight: '400px',
            overflowY: 'auto'
        },
        subcategoryTitle: {
            fontSize: '10px',
            fontWeight: '600',
            color: darkMode ? '#64748b' : '#9aabbf',
            textTransform: 'uppercase',
            letterSpacing: '0.3px',
            margin: '0 0 2px 4px'
        },
        pageLink: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 12px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontSize: '12px',
            lineHeight: '1.4',
            color: darkMode ? '#cbd5e1' : '#4a5a6e',
            backgroundColor: darkMode ? '#1e293b' : '#f9fcff',
            border: darkMode ? '1px solid #334155' : '1px solid #f0f4fa',
            transition: 'all 0.2s',
            cursor: 'pointer'
        },
        pageLinkHover: {
            backgroundColor: darkMode ? '#334155' : '#ffffff',
            borderColor: darkMode ? '#475569' : '#d0ddeb',
            boxShadow: darkMode ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.02)'
        },
        pageTitle: {
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            paddingRight: '8px',
            fontSize: '12px'
        },
        collapsedPreview: {
            padding: '12px 16px',
            backgroundColor: darkMode ? '#1e293b' : '#ffffff',
            color: darkMode ? '#64748b' : '#8a9bb5',
            fontSize: '11px',
            fontStyle: 'italic'
        },
        statsContainer: {
            marginTop: '32px',
            paddingTop: '24px',
            borderTop: darkMode ? '1px solid #1e293b' : '1px solid #eaeef2',
            display: 'flex',
            justifyContent: 'center',
            gap: '32px',
            flexWrap: 'wrap'
        },
        statNumber: {
            fontSize: '16px',
            fontWeight: '500',
            color: darkMode ? '#f1f5f9' : '#1e2a3a'
        },
        statLabel: {
            fontSize: '11px',
            color: darkMode ? '#64748b' : '#8a9bb5'
        },
        freeAccess: {
            fontSize: '16px',
            fontWeight: '500',
            color: '#f5b342'
        },
        instruction: {
            marginTop: '20px',
            textAlign: 'center',
            fontSize: '10px',
            color: darkMode ? '#475569' : '#b1c3d8',
            letterSpacing: '0.2px'
        }
    };

    return (
        <>
            <Helmet>
                {/* Generate all blog links for search engines */}
                {data.categories.map((category) =>
                    category.subCategories.map((subCategory, subIndex) =>
                        subCategory.pages.map((page) => (
                            <link
                                key={`${category.category}-${subIndex}-${page.id}-seo`}
                                rel="prefetch"
                                href={constructUrl(category.category, subIndex, page.fileName)}
                            />
                        ))
                    )
                )}

                {/* Optional: Add a sitemap link */}
                <link rel="sitemap" type="application/xml" title="Sitemap" href="/sitemap.xml" />

                {/* Optional: Add meta description about your content */}
                <meta name="description" content={`Access ${totalArticles} free study resources across ${data.categories.length} categories including ${data.categories.map(c => c.category).join(', ')}`} />
            </Helmet>
            <div style={styles.container}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: '36px 20px'
                }}>
                    {/* Header */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '28px'
                    }}>
                        <FaSitemap style={{ width: '18px', height: '18px', color: styles.headerIcon.color }} />
                        <h2 style={styles.headerTitle}>
                            All Study Resources
                        </h2>
                        <div style={styles.headerDivider}></div>
                        <span style={styles.headerCount}>
                            {totalArticles} topics
                        </span>
                    </div>

                    {/* Accordion Grid */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(1, 1fr)',
                        gap: '12px'
                    }}>
                        <style>
                            {`
                            @media (min-width: 640px) {
                                .accordion-grid {
                                    grid-template-columns: repeat(2, 1fr) !important;
                                }
                            }
                            @media (min-width: 1024px) {
                                .accordion-grid {
                                    grid-template-columns: repeat(4, 1fr) !important;
                                }
                            }
                        `}
                        </style>

                        {data.categories.map((category) => {
                            const isExpanded = expandedCategories[category.category];
                            const categoryTotal = category.subCategories.reduce((acc, sub) => acc + sub.pages.length, 0);

                            return (
                                <div key={category.category} style={styles.categoryCard}>
                                    {/* Accordion Header - Clickable */}
                                    <div
                                        onClick={() => toggleCategory(category.category)}
                                        style={{
                                            ...styles.categoryHeader,
                                            ...(isExpanded ? styles.categoryHeaderExpanded : {})
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = darkMode ? '#334155' : '#f0f7ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = darkMode ? '#1e293b' : '#f9fcff';
                                        }}
                                    >
                                        <span style={{ color: categoryColors[category.category] }}>
                                            {categoryIcons[category.category] || <FaBook style={{ width: '15px', height: '15px' }} />}
                                        </span>
                                        <h3 style={styles.categoryTitle}>
                                            {category.category}
                                        </h3>
                                        <span style={styles.categoryCount}>
                                            {categoryTotal}
                                        </span>
                                        {isExpanded ?
                                            <FaChevronDown style={{ width: '12px', height: '12px', color: styles.chevronIcon.color }} /> :
                                            <FaChevronRight style={{ width: '12px', height: '12px', color: styles.chevronIcon.color }} />
                                        }
                                    </div>

                                    {/* Accordion Content - All links visible when expanded */}
                                    {isExpanded && (
                                        <div style={styles.expandedContent}>
                                            {/* All Links - No truncation, everything visible */}
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                                {category.subCategories.map((subCategory, subIndex) => (
                                                    <div key={subCategory.title} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                                        {/* Subcategory Title */}
                                                        <h4 style={styles.subcategoryTitle}>
                                                            {subCategory.title}
                                                        </h4>

                                                        {/* ALL Page Links - No "more" links */}
                                                        {subCategory.pages.map((page) => (
                                                            <a
                                                                key={`${category.category}-${subIndex}-${page.id}`}
                                                                href={constructUrl(category.category, subIndex, page.fileName)}
                                                                style={styles.pageLink}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = styles.pageLinkHover.backgroundColor;
                                                                    e.currentTarget.style.borderColor = styles.pageLinkHover.borderColor;
                                                                    e.currentTarget.style.boxShadow = styles.pageLinkHover.boxShadow;
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = styles.pageLink.backgroundColor;
                                                                    e.currentTarget.style.borderColor = styles.pageLink.borderColor;
                                                                    e.currentTarget.style.boxShadow = 'none';
                                                                }}
                                                            >
                                                                <span style={styles.pageTitle}>
                                                                    {page.fileTitle}
                                                                </span>
                                                                {page.subscriptionRequired && (
                                                                    <FaStar style={{
                                                                        width: '10px',
                                                                        height: '10px',
                                                                        color: '#f5b342',
                                                                        flexShrink: 0
                                                                    }} />
                                                                )}
                                                            </a>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* When collapsed, show minimal preview */}
                                    {!isExpanded && (
                                        <div style={styles.collapsedPreview}>
                                            {category.subCategories.length} subcategories · Click to expand
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>

                    {/* Simple Stats */}
                    <div style={styles.statsContainer}>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                            <span style={styles.statNumber}>{data.categories.length}</span>
                            <span style={styles.statLabel}>categories</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                            <span style={styles.statNumber}>{totalArticles}</span>
                            <span style={styles.statLabel}>total articles</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                            <span style={styles.freeAccess}>✦ Free</span>
                            <span style={styles.statLabel}>access</span>
                        </div>
                    </div>

                    {/* Instruction */}
                    <div style={styles.instruction}>
                        Click on any category to expand and view all topics
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubFooter;